import { useState } from "react";
import type { ReactNode } from "react";

type Placement = "top" | "bottom" | "left" | "right";

interface TooltipProps {
    content: ReactNode;
    children: ReactNode;
    placement?: Placement;
    multiline?: boolean;
    className?: string;
}

const PLACEMENT_CLASSES: Record<Placement, string> = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

export const Tooltip = ({
    content,
    children,
    placement = "top",
    multiline = false,
    className = "",
}: TooltipProps) => {
    const [visible, setVisible] = useState(false);
    const wrapClass = multiline ? "whitespace-normal max-w-xs w-max" : "whitespace-nowrap w-max";

    return (
        <div
            className={`relative inline-flex ${className}`}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            onFocus={() => setVisible(true)}
            onBlur={() => setVisible(false)}
        >
            {children}
            {visible && content && (
                <div
                    role="tooltip"
                    className={`absolute z-[1000] bg-black/85 text-white rounded px-3 py-2 text-sm leading-relaxed pointer-events-none ${wrapClass} ${PLACEMENT_CLASSES[placement]}`}
                >
                    {content}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
